import { useQuery } from "@tanstack/react-query";
import { getClientBalance } from "api/client.api";
import { DEFAULT_STALE_TIME } from "config/constants";

export const useGetClientBalance = (clientId, params = {}) => {
  return useQuery({
    queryKey: ["clients", clientId, "balance", params],
    queryFn: () => getClientBalance(clientId, params),
    enabled: !!clientId,
    staleTime: DEFAULT_STALE_TIME,
  });
};
